export default function AttachAgendaItemDocumentDirective() {
  return {
    template: require('./attach-agendaItem-document.html'),
    scope: {
      customerId: '=',
      agendaItemId: '=',
      serviceId: '=',
      parentDocumentId: '=',
      documentId: '=',
      document: '=',
    },
    controller: 'AttachAgendaItemDocumentController',
    controllerAs: 'attachAgendaItemDocumentVM',
    bindToController: true,
    replace: true
  };
}
